import { ApiClient } from '@listening/api-contract/api-client-tag';
import { Atom } from 'effect/reactivity';
import { Duration, Effect } from 'effect';
import { apiQuery } from './api-runtime';

export const getFlagsEffect = Effect.flatMap(ApiClient, (api) =>
  api.Flags.Get(),
);

/** Reactivity key for the viewer's flags. */
export const flagsKey = 'flags';

const viewerFlags = (staleTime: Duration.Input) =>
  Atom.family((_viewerId: string | null) =>
    apiQuery(getFlagsEffect, { staleTime, reactivityKeys: [flagsKey] }),
  );

/**
 * The viewer's `Flags.Get` response, one per viewer (`null` when signed out),
 * so a response is never saved under another viewer. Read one flag with
 * `readInstantClientFlag` or `useWaitingClientFlag`, which decode it with the
 * flag's schema and fall back as its `whileUnknown` says.
 */
export const flagsAtom = viewerFlags(Duration.minutes(5));

/** `flagsAtom`, refetched every time the app comes to the foreground: a stage
 * override is the kill switch, and must reach the app on every foreground,
 * not only once the cached response is stale. */
export const foregroundFlagsAtom = viewerFlags(Duration.zero);
